export const SET_COMPANY_PROPERTIES = 'SET_COMPANY_PROPERTIES'
export const RESET_COMPANY_PROPERTIES = 'RESET_COMPANY_PROPERTIES'
